










































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { api as deskApi } from "../../store/modules/desk";
import { api as userApi } from "../../store/modules/user";

import { DeckInfo, Decks } from "../../store/modules/desk/types";
import {
  Announcement,
  AnnouncementValues,
  GameState,
  ItemRef,
} from "@dokogd/shared";
import { Dictionary } from "lodash";

@Component({})
export default class DoKoPlayerInfo extends Vue {
  readonly SIZE = 72;
  @Prop({
    type: Number,
    default: 1,
  })
  private scale!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private x!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private y!: number;

  @Prop({
    type: String,
    required: true,
  })
  private placeName!: "bottom" | "left" | "top" | "right";

  @Getter(deskApi.getters.getDecks, { namespace: deskApi.namespace })
  decks!: Decks;

  @Getter(deskApi.getters.getActivePlayerId, { namespace: deskApi.namespace })
  activePlayerId!: string;

  @Getter(deskApi.getters.getGameState, { namespace: deskApi.namespace })
  gameState!: GameState;

  @Getter(deskApi.getters.getPovertyCardCount, { namespace: deskApi.namespace })
  povertyCardCount!: number;

  @Getter(deskApi.getters.getLeadId, { namespace: deskApi.namespace })
  leadId!: string;

  @Getter(userApi.getters.getUserId, { namespace: userApi.namespace })
  userId!: string | null;

  @Action(deskApi.actions.sendAnnouncement, { namespace: deskApi.namespace })
  sendAnnouncement!: (value: AnnouncementValues) => Promise<void>;

  get isMyDeck(): boolean {
    console.log("isMyDeck", this.nextAnnouncement);
    return this.owner.id === this.userId && this.nextAnnouncement !== null;
  }

  get nextAnnouncmentImage(): string {
    // `/img/symbols.svg#symbol-${imagePrefix}-${announcement.value}`
    return `/img/symbols.svg#symbol-ansage`;
  }
  /*const announcement = this.announcement;
    if (announcement) {
      const imagePrefix = announcement.side === "reDouble" ? "re" : "kontra";
      return `/img/symbols.svg#symbol-${imagePrefix}-${announcement.value}`;
    } else {
      return null;
    } */
  get activeAnnouncement(): null | string {
    const announcement = this.nextAnnouncement;
    if (announcement) {
      const imagePrefix = announcement.side === "reDouble" ? "re" : "kontra";
      return `/img/symbols.svg#symbol-${imagePrefix}-${announcement.value}`;
    } else {
      return null;
    }
  }

  //

  get isActivePlayer(): boolean {
    return this.activePlayerId === this.owner.id;
  }

  get deckInfo(): DeckInfo {
    return this.decks[this.placeName];
  }

  get owner(): ItemRef {
    return this.deckInfo.owner;
  }

  get avatarId(): string | null {
    return this.owner.avatarId;
  }

  get displayName(): string {
    return this.owner.displayName;
  }

  get transformText(): string {
    return `translate(${this.x} ${this.y}) scale(${this.scale})`;
  }

  get announcement(): Announcement | null {
    return this.deckInfo.announcement;
  }

  get nextAnnouncement(): Announcement | null {
    return this.deckInfo.nextAnnouncement;
  }

  get isPovertyCheck(): boolean {
    return (
      this.isActivePlayer &&
      (this.gameState === "povertyCheck" || this.gameState === "returnPoverty")
    );
  }

  get announcementStyle(): Dictionary<unknown> {
    if (this.gameState === "povertyCheck") {
      return {
        opacity: 0.25,
      };
    } else {
      return {};
    }
  }
  get activeAnnouncementImage(): string | null {
    console.log(
      "activeAnnouncementImage",
      this.gameState,
      this.isActivePlayer,
      this.displayName
    );
    if (this.isPovertyCheck) {
      return this.povertyCardCount === 4
        ? `/img/symbols.svg#symbol-poverty-fox`
        : `/img/symbols.svg#symbol-poverty`;
    }

    const announcement = this.announcement;
    if (announcement) {
      const imagePrefix = announcement.side === "reDouble" ? "re" : "kontra";
      return `/img/symbols.svg#symbol-${imagePrefix}-${announcement.value}`;
    } else {
      return null;
    }
  }

  get infoLine(): string {
    return this.owner.id === this.leadId ? "Erstes Aufspiel" : "";
  }

  get avatar(): string {
    return "/img/avatars.svg#avatar-" + this.avatarId;
  }

  get announcmentX(): number {
    return this.placeName === "right" ? 0 : this.SIZE + 8;
  }

  get avatarX(): number {
    return this.placeName !== "right" ? 0 : this.SIZE + 8;
  }

  get textAnchor(): string {
    return this.placeName !== "right" ? "start" : "end";
  }

  get offset(): number {
    return this.placeName !== "right" ? 0 : this.SIZE * 2 + 8;
  }

  makeAnnouncement(): void {
    console.log("makeAnnouncement", this.nextAnnouncement);
    if (this.nextAnnouncement) {
      this.sendAnnouncement(this.nextAnnouncement.value)
        .then(() => {
          console.log("SendAnnouncement done");
        })
        .catch(err => {
          console.error("SendAnnouncement failed", err);
        });
    }
  }
}
